import React from 'react';
import { SignInPage } from '@toolpad/core/SignInPage';

const SignInForm = (props) => {
  const providers = [
    { id: 'google', name: 'Google' },
  ];

  const signIn = async (provider) => {
    props.googleSignIn();
  };

  return (
    <SignInPage signIn={signIn} providers={providers} />
  );
};

export default SignInForm;

